"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _DraggableContext = _interopRequireDefault(require("./DraggableContext"));

var _DraggableHandle = _interopRequireDefault(require("./DraggableHandle"));

var Draggable =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Draggable, _React$Component);

  function Draggable(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Draggable);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Draggable).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleMouseDown", function (e) {
      var clientX;
      var clientY;
      var moveEvent;
      var endEvent;

      if (!_this.isTouchDevice) {
        e.preventDefault();
        clientX = e.clientX;
        clientY = e.clientY;
        moveEvent = 'onmousemove';
        endEvent = 'onmouseup';
      } else {
        clientX = e.touches[0].clientX;
        clientY = e.touches[0].clientY;
        moveEvent = 'ontouchmove';
        endEvent = 'ontouchend';
      }

      _this.currentX = clientX;
      _this.currentY = clientY;

      _this.setState({
        cursor: 'grabbing'
      });

      var container = _this.props.container;
      container[moveEvent] = _this.handleMouseMove;
      container[endEvent] = _this.handleMouseUp;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleMouseUp", function () {
      var moveEvent;
      var endEvent;

      if (!_this.isTouchDevice) {
        moveEvent = 'onmousemove';
        endEvent = 'onmouseup';
      } else {
        moveEvent = 'ontouchmove';
        endEvent = 'ontouchend';
      }

      _this.setState({
        cursor: 'grab'
      });

      var container = _this.props.container;
      container[moveEvent] = null;
      container[endEvent] = null;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleMouseMove", function (e) {
      var clientX;
      var clientY;

      if (!_this.isTouchDevice) {
        e.preventDefault();
        clientX = e.clientX;
        clientY = e.clientY;
      } else {
        clientX = e.touches[0].clientX;
        clientY = e.touches[0].clientY;
      }

      var distanceX = _this.currentX - clientX;
      var distanceY = _this.currentY - clientY;
      _this.currentX = clientX;
      _this.currentY = clientY;
      var left = _this.node.offsetLeft - distanceX;
      var top = _this.node.offsetTop - distanceY;

      _this.setState({
        position: {
          top: top,
          left: left
        }
      });
    });
    _this.currentX = 0;
    _this.currentY = 0;
    _this.state = {
      position: null,
      cursor: 'grab'
    };
    _this.isTouchDevice = 'ontouchstart' in window || navigator.msMaxTouchPoints > 0;
    return _this;
  }

  (0, _createClass2.default)(Draggable, [{
    key: "render",
    value: function render() {
      var _ref,
          _this2 = this;

      var position = this.state.position;
      var style = position ? {
        top: position.top,
        left: position.left
      } : undefined;

      var child = _react.default.Children.only(this.props.children);

      var startEvent = this.isTouchDevice ? 'onTouchStart' : 'onMouseDown';
      var endEvent = this.isTouchDevice ? 'onTouchEnd' : 'onMouseUp';
      return _react.default.createElement(_DraggableContext.default.Provider, {
        value: (_ref = {}, (0, _defineProperty2.default)(_ref, startEvent, this.handleMouseDown), (0, _defineProperty2.default)(_ref, endEvent, this.handleMouseUp), (0, _defineProperty2.default)(_ref, "cursor", this.state.cursor), (0, _defineProperty2.default)(_ref, "startEvent", startEvent), _ref)
      }, _react.default.cloneElement(child, {
        style: style,
        ref: function ref(node) {
          _this2.node = node;
          var ref = child.ref;
          if (typeof ref === 'function') ref(node);else if (ref) ref.current = node;
        }
      }));
    }
  }]);
  return Draggable;
}(_react.default.Component);

Draggable.Handle = _DraggableHandle.default;
Draggable.defaultProps = {
  container: document
};
Draggable.prototypes = {
  container: _propTypes.default.instanceOf(Element)
};
var _default = Draggable;
exports.default = _default;